import React, { useState } from "react";
import { IconButton, CircularProgress, Tooltip } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import HttpService from "../services/httpService";


export default function AadhaarReveal({ ownerId, fetcher, masked, setSnackInfo }) {
  const [revealed, setRevealed] = useState(false);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const canReveal = typeof fetcher === "function" || !!ownerId;

  const toggle = async () => {
    if (revealed) {
      setRevealed(false);
      return;
    }
    if (value) {
      setRevealed(true);
      return;
    }
    setLoading(true);
    try {
      const res = typeof fetcher === "function"
        ? await fetcher()
        : await HttpService.getRentalOwnerAadhaar(ownerId);
      setValue(res?.data?.data?.aadhaar || "");
      setRevealed(true);
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to fetch Aadhaar number";
      if (typeof setSnackInfo === "function") setSnackInfo(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span>{revealed ? value : (masked || "Encrypted")}</span>
      {canReveal && (
        <Tooltip title={revealed ? "Hide Aadhaar" : "View Aadhaar"}>
          <IconButton size="small" onClick={toggle} disabled={loading} style={{ padding: 4 }}>
            {loading
              ? <CircularProgress size={14} />
              : revealed
                ? <VisibilityOff style={{ fontSize: 16 }} />
                : <Visibility style={{ fontSize: 16 }} />}
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
}
